import React, { useState, useEffect } from 'react';
import { pdfjs, Document, Page } from 'react-pdf';
import { Grid } from '@mui/material';
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
// import "./style.css";

const PdfViewModal = (props) => {
  pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

  const [numPages, setNumPages] = useState(null);
  const [uri, setUri] = useState(null);

  useEffect(() => {
    let pdfUri = `${process.env.REACT_APP_SERVER_API}:${process.env.REACT_APP_PORT_DATA.split(",")[0]}/manuals/${props.filename}`;
    setUri(pdfUri)
  }, [props.filename]);

  function onDocumentLoadSuccess({ numPages }){
    setNumPages(numPages);
  }

  return (
    <Grid container sx={{ flexDirection: "column", justifyContent: 'center', alignItems: 'center' }}>
      <Grid item xs={12}>
        {uri &&
          <Document
            file={uri}
            onLoadSuccess={onDocumentLoadSuccess}
          >
            {Array.from(
              new Array(numPages),
              (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  scale={60 / 30}
                />
              ),
            )}
          </Document>
        }
      </Grid>
    </Grid>
  );
};

export default PdfViewModal;